import qs from "qs";
import { findRecurrentPayments } from "../../infrastructure/repository/recurrent-payments-repository";
import RecurrentPayment from "../../app/domain/RecurrentPayment";
import { adaptRecurrentPayments } from "../../infrastructure/adapters/adaptRecurrentPayments";
import { translate as t } from "../../infrastructure/translate/localization";
import { showErrorMessage } from "../commons/show-error-message";

export default async function fetchRecurrentPayments({
  companyId,
  params,
  callback,
}: {
  companyId: string;
  params: any;
  callback(e: any, extraData: number): void;
}): Promise<void> {
  try {
    const { data } = await findRecurrentPayments({
      companyId,
      params: qs.stringify(params, { skipNulls: true }),
    });
    const { content, metainfo } = data;
    const { pagination } = metainfo;
    callback(
      content.map((item) => new RecurrentPayment(adaptRecurrentPayments(item))),
      pagination.totalItems
    );
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
